export default __webpack_public_path__ + "static/FancyMediaContentFive-8d24ea65cacc48e17f373f8e8fa36aed.webp";